import { useMutation, useQueryCache } from 'react-query';
import { TournamentAPI } from 'api/admin/tournament';
import { TOURNAMENT } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdateTournament() {
  const queryCache = useQueryCache();

  return useMutation(TournamentAPI.updateTournament, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(TOURNAMENT);
      dispatchToast({ message, type: 'success' });
      onSuccess();
    },
  });
}
